<template>
  <el-row type="flex" class="w-full">
    <el-col :xs="24" :sm="8" :md="8" :lg="6" :xl="6">
      <div class="p-2 border-r-2 border-gray-50 h-full">
        <el-input
          placeholder="Filter keyword"
          v-model="search"
        ></el-input>

        <div class="m-2"></div>

        <el-tree
          ref="tree"
          :data="tree"
          node-key="path"
          :render-content="treeNodeContent"
          highlight-current
          @node-click="select"
          :filter-node-method="filterTree"
        ></el-tree>
      </div>
    </el-col>
    <el-col
      :xs="24"
      :sm="16"
      :md="16"
      :lg="18"
      :xl="18"
      v-loading="loadingContent"
    >
      <div
        class="h-full overflow-scroll p-2"
        v-if="!loadingContent"
      >
        <pre
          class="prettyprint"
        ><code>{{ content }}</code></pre>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'app-project-file-explorer',

  data() {
    return {
      search: '',
    };
  },

  computed: {
    ...mapGetters({
      files: 'project/files',
      tree: 'project/tree',
      content: 'project/content',
      loadingContent: 'project/loadingContent',
    }),
  },

  watch: {
    search(val) {
      this.$refs.tree.filter(val);
    },
  },

  methods: {
    treeNodeContent(h, { data, node }) {
      let iconProperties = null;

      if (data.directory) {
        if (node.expanded) {
          iconProperties = {
            class: 'fas fa-folder-open text-yellow-300',
          };
        } else {
          iconProperties = {
            class: 'fas fa-folder text-yellow-300',
          };
        }
      } else {
        iconProperties = { class: 'far fa-file' };
      }

      return h('span', [
        h('i', iconProperties),
        h('span', ` ${data.name}`),
      ]);
    },

    filterTree(value, data) {
      if (!value) {
        return true;
      }

      return data.name
        .toLowerCase()
        .includes(value.toLowerCase());
    },

    select(element) {
      this.$store
        .dispatch('project/selectFromTree', element)
        .then(() => {
          return Vue.nextTick();
        })
        .then(() => {
          /* eslint-disable no-undef */
          PR.prettyPrint();
        });
    },
  },
};
</script>

<style></style>
